import * as Utils from './components/utils.js';

const Rgpd = (onexec, onexempt) => {
    const cookieName = 'pep';
    const cookieDuration = 30;
    const strictmode = true;
    const modal = document.querySelector('.rgpd-modal');
    const manage = document.querySelector('.rgpd-manage');
    const btn_accept = document.querySelector('.rgpd-btn-accept');
    const btns_refuse = document.querySelectorAll('.rgpd-btn-refuse');
    const btn_save = document.querySelector('.rgpd-btn-save');
    const checkboxes = manage.querySelectorAll('input[type="radio"]');


    let cats = {};
    const Cookie = {
        create(name, value, days) {
            let expires = '';
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = `; expires=${date.toGMTString()}`;
            }
            document.cookie = `${name}=${value}${expires}; path=/`;
        },
        read(name) {
            const nameEQ = `${name}=`;
            const cas = document.cookie.split(';');
            for (let i = 0; i < cas.length; i++) {
                let ca = cas[i];
                while (ca.charAt(0) === ' ') ca = ca.substring(1, ca.length);
                if (ca.indexOf(nameEQ) === 0) return ca.substring(nameEQ.length, ca.length);
            }
            return null;
        },
        erase(name) {
            let hostname = document.location.hostname;
            if (hostname.indexOf('www.') === 0) {
                hostname = hostname.substring(4);
            }
            document.cookie = `${name}=; domain=.${hostname}; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;
            document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;
        },
        eraseUnused() {
            for (const checkbox of checkboxes) {
                if (checkbox.checked === false) {
                    checkbox.getAttribute('data-cookies').split(',').forEach(cookie => Cookie.erase(cookie));
                }
            }
        },
    };

    let consent = Cookie.read(cookieName) ? true : false;



    // fire event onexec if cat == true
    const _execute = () => {
        for (const key in cats) {
            if (cats[key] == 'true' || cats[key] == true) {
                console.log('- ', cats[key]);
                if (typeof onexec === 'function') onexec(key);
            }
        }
    };

    // set cookie obj status
    const _status = () => {
        checkboxes.forEach(item => {
            if (item.checked && item.name !== 'mandatory') {
                cats[item.name] = item.value;
            }
        });
    }

    // set consent cookie (rgpd)
    const _consent = () => {

        consent = true;
        modal.classList.add('hide');
        Cookie.create(cookieName, JSON.stringify(cats), cookieDuration);

        if (cats.stats == true || cats.stats == "true") {
            if (window.pa) {
                pa.privacy.setMode('optin');
            }
        } else {
            if (window.pa) {
                pa.privacy.setMode('exempt');
                if (typeof onexempt === 'function') onexempt();
            }
        }
    };

    // accept in alert
    const _accept = () => {
        checkboxes.forEach(item => {
            if (item.value == "true" && item.name !== 'mandatory') {
                item.checked = true;
                cats[item.name] = true;
            }
        });

        _status();
        _execute();
        _consent();
    };

    // refuse in alert
    const _refuse = () => {
        checkboxes.forEach(item => {
            if (item.value == "false" && item.name !== 'mandatory') {
                item.checked = false;
                cats[item.name] = false;
            }
        });

        _status();
        _consent();
    };

    // Save modification
    const _save = () => {
        _status();
        if (!consent) _execute();
        _consent();
        Cookie.eraseUnused();

        Utils.closeDsfrModal('fr-consent-modal');
    };

    // init or load cookie obj
    if (consent === true) cats = JSON.parse(Cookie.read(cookieName));
    else if (!strictmode) {
        _status();
        // checkboxes.forEach(checkbox => cats[checkbox.value] = true);

        checkboxes.forEach(item => {
            if (item.value == "true" && item.name !== 'mandatory') {
                item.checked = true;
                cats[item.name] = true;
            }
        });

        _execute();
    } else {

        modal.classList.remove('hide');
        checkboxes.forEach(item => {
            if (item.value == "false" && item.name !== 'mandatory') {
                item.checked = false;
                cats[item.name] = false;
            }
        });

    }

    // init checkboxes checked
    for (let key in cats) {
        for (const checkbox of checkboxes) {
            if (checkbox.value == key) checkbox.checked = cats[key];
        }
    }

    btn_accept.onclick = () => _accept();

    btns_refuse.forEach(btn_refuse => btn_refuse.onclick = () => _refuse());

    consent == true ? _execute() : '';

    // onexempt 
    if (cats.stats == true || cats.stats == "true") {
        if (window.pa) { pa.privacy.setMode('optin'); }
    } else {
        if (window.pa) {
            pa.privacy.setMode('exempt');
            if (typeof onexempt === 'function') onexempt();
        }
    }


    if (window.pa) {
        consent == true ? pa.privacy.setMode('optin') : pa.privacy.setMode('exempt');
    }

    btn_save.onclick = () => _save();
};

window.Rgpd = Rgpd;

export default Rgpd;
